import { useEffect } from 'react';
import { match } from 'ts-pattern';
import { useThisSiloAddress } from './hooks';
import { useSilo } from './useSilo';

export const useThisNullableSilo = () => {
  const siloAddress = useThisSiloAddress();
  return useSilo(siloAddress);
};

export const useThisSilo = () => {
  const result = useThisNullableSilo();
  const silo = result.status === 'graph' || result.status === 'contracts' ? result.data : null;

  useEffect(() => {
    match(result)
      .with({ status: 'contracts' }, (contracts) => {
        console.warn('Silo fell back to contracts', contracts.errors);
      })
      .with({ status: 'error' }, (error) => {
        console.error('Silo failed to load', error.errors);
      })
      .otherwise(() => ({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.status]);

  if (!silo) throw new Error('Silo not found');

  return silo;
};
